import { type JSX } from 'react';

import { NoContent } from '@cx-modules/ui';

import { type Bet } from '../../types';
import { MarketExpanderBet } from '../MarketExpanderBet';

import { ExpanderBestOddsContent, ExpanderBestOddsRow, ExpanderBestOddsWrapper } from './style';

interface MarketExpanderSimpleProps {
  bets: Array<
    Bet & {
      bestOdds: number;
      bestOddsFractional: string;
      bestOddsText: string | number;
    }
  >;
}

const MAX_NUMBER_OF_COLUMNS = 3;

export const MarketExpanderSimple = ({ bets }: MarketExpanderSimpleProps): JSX.Element => {
  const numberOfBets = bets.length;
  const numberOfColumns = Math.min(numberOfBets, MAX_NUMBER_OF_COLUMNS);

  const numberOfVisibleRows = numberOfColumns === 0 ? 0 : Math.ceil(bets.length / numberOfColumns);

  const showNoContent = bets.filter(bet => bet.odds.length > 0).length === 0;
  if (showNoContent) return <NoContent>No odds available at the moment. Check again later.</NoContent>;

  return (
    <ExpanderBestOddsWrapper>
      {[...Array(numberOfVisibleRows).keys()].map(rowIndex => (
        <ExpanderBestOddsRow key={rowIndex}>
          <ExpanderBestOddsContent numberOfColumns={numberOfColumns}>
            {[...Array(numberOfColumns).keys()].map(columnIndex => {
              const betIndex = rowIndex * numberOfColumns + columnIndex;
              const bet = bets[betIndex];
              if (!bet) return null;
              return <MarketExpanderBet bet={bet} isFirst={betIndex === 0} key={bet.id} />;
            })}
          </ExpanderBestOddsContent>
        </ExpanderBestOddsRow>
      ))}
    </ExpanderBestOddsWrapper>
  );
};
